import { render } from "./RulesView.vue?vue&type=template&id=2bc12350&scoped=true"
import script from "./RulesView.vue?vue&type=script&lang=js"
export * from "./RulesView.vue?vue&type=script&lang=js"

import "./RulesView.vue?vue&type=style&index=0&id=2bc12350&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc12350"]])

export default __exports__